
    import './styles.scoped.css';
    export default {
  "icon": "awsui_icon_k5dlb_ssrwu_93",
  "top-navigation": "awsui_top-navigation_k5dlb_ssrwu_111",
  "padding-box": "awsui_padding-box_k5dlb_ssrwu_122",
  "medium": "awsui_medium_k5dlb_ssrwu_132",
  "narrow": "awsui_narrow_k5dlb_ssrwu_132",
  "virtual": "awsui_virtual_k5dlb_ssrwu_143",
  "hidden": "awsui_hidden_k5dlb_ssrwu_147",
  "\t": "awsui_\t_k5dlb_ssrwu_1",
  "identity": "awsui_identity_k5dlb_ssrwu_159",
  "identity-link": "awsui_identity-link_k5dlb_ssrwu_162",
  "no-logo": "awsui_no-logo_k5dlb_ssrwu_179",
  "logo": "awsui_logo_k5dlb_ssrwu_183",
  "title": "awsui_title_k5dlb_ssrwu_194",
  "inputs": "awsui_inputs_k5dlb_ssrwu_207",
  "search": "awsui_search_k5dlb_ssrwu_214",
  "search-expanded": "awsui_search-expanded_k5dlb_ssrwu_218",
  "utilities": "awsui_utilities_k5dlb_ssrwu_222",
  "utility-wrapper": "awsui_utility-wrapper_k5dlb_ssrwu_233",
  "utility-type-button-link": "awsui_utility-type-button-link_k5dlb_ssrwu_254",
  "utility-type-menu-dropdown": "awsui_utility-type-menu-dropdown_k5dlb_ssrwu_258",
  "utility-type-button-primary-button": "awsui_utility-type-button-primary-button_k5dlb_ssrwu_266",
  "utility-link-icon": "awsui_utility-link-icon_k5dlb_ssrwu_274",
  "utility-button-external-icon": "awsui_utility-button-external-icon_k5dlb_ssrwu_278",
  "offset-right-none": "awsui_offset-right-none_k5dlb_ssrwu_282",
  "offset-right-l": "awsui_offset-right-l_k5dlb_ssrwu_286",
  "offset-right-xxl": "awsui_offset-right-xxl_k5dlb_ssrwu_290",
  "overflow-menu-drawer": "awsui_overflow-menu-drawer_k5dlb_ssrwu_295",
  "overflow-menu": "awsui_overflow-menu_k5dlb_ssrwu_295",
  "overflow-menu-header": "awsui_overflow-menu-header_k5dlb_ssrwu_315",
  "overflow-menu-header-text": "awsui_overflow-menu-header-text_k5dlb_ssrwu_322",
  "overflow-menu-header-text--secondary": "awsui_overflow-menu-header-text--secondary_k5dlb_ssrwu_331",
  "overflow-menu-header-text--title": "awsui_overflow-menu-header-text--title_k5dlb_ssrwu_337",
  "overflow-menu-back-button": "awsui_overflow-menu-back-button_k5dlb_ssrwu_341",
  "overflow-menu-dismiss-button": "awsui_overflow-menu-dismiss-button_k5dlb_ssrwu_345",
  "overflow-menu-control": "awsui_overflow-menu-control_k5dlb_ssrwu_349",
  "overflow-menu-list-item-utility": "awsui_overflow-menu-list-item-utility_k5dlb_ssrwu_364",
  "overflow-menu-control-link": "awsui_overflow-menu-control-link_k5dlb_ssrwu_371",
  "overflow-menu-control-expandable-menu-trigger": "awsui_overflow-menu-control-expandable-menu-trigger_k5dlb_ssrwu_374",
  "overflow-menu-list": "awsui_overflow-menu-list_k5dlb_ssrwu_364",
  "overflow-menu-list-submenu": "awsui_overflow-menu-list-submenu_k5dlb_ssrwu_405",
  "overflow-menu-list-item": "awsui_overflow-menu-list-item_k5dlb_ssrwu_364",
  "overflow-menu-list-item-icon": "awsui_overflow-menu-list-item-icon_k5dlb_ssrwu_413",
  "overflow-menu-list-item-text": "awsui_overflow-menu-list-item-text_k5dlb_ssrwu_416",
  "overflow-menu-list-item-submenu": "awsui_overflow-menu-list-item-submenu_k5dlb_ssrwu_423",
  "overflow-menu-list-item-dropdown-menu": "awsui_overflow-menu-list-item-dropdown-menu_k5dlb_ssrwu_428",
  "overflow-menu-list-item-expandable": "awsui_overflow-menu-list-item-expandable_k5dlb_ssrwu_431",
  "expanded": "awsui_expanded_k5dlb_ssrwu_439"
};
  